import React from "react"
import styles from "./brands.module.css"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const AllBrands = () => {

  const data = useStaticQuery(graphql`
      query {
          img1: file(relativePath: { eq: "logos/babystyle.png" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img2: file(relativePath: { eq: "logos/cosatto.png" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img3: file(relativePath: { eq: "logos/hauk.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img4: file(relativePath: { eq: "logos/ickkle-bubba.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img5: file(relativePath: { eq: "logos/maxi-cosi.png" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img6: file(relativePath: { eq: "logos/mybabiie.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img7: file(relativePath: { eq: "logos/obaby.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img8: file(relativePath: { eq: "logos/red-kite.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img9: file(relativePath: { eq: "logos/vennicii.png" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return (
    <div className={styles.allBrands}>
      <div className='container'>
        <h4 className='text-center m-5'>We also have Brand New Stock from the following brands</h4>
        <div className={styles.flexContainer}>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="babystyle" fluid={data.img1.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="cosatto" fluid={data.img2.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="hauk" fluid={data.img3.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="ickle-bubba" fluid={data.img4.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="maxi-cosi" fluid={data.img5.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="my-babiie" fluid={data.img6.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="obaby" fluid={data.img7.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="redkite" fluid={data.img8.childImageSharp.fluid}/>
          </div>
          <div className={styles.flexItem}>
            <Img className='img-fluid' alt="venicci" fluid={data.img9.childImageSharp.fluid}/>
          </div>
        </div>
        <hr className='divider'/>
      </div>
    </div>
  )
}

export default AllBrands
